import React, { useEffect } from "react";
import KioskStartButton from "../components/start-button";
import ArrowBack from "../assets/arrow-back.svg";
import { useTranslation } from "react-i18next";
import GiftCard from "assets/giftcardPict.jpg";
import { calculateEstimate } from "lib/calculateEstimate";
import useLocalizedCurrencyValue from "hooks/useLocalizedCurrencyValue";
import useWhen from "hooks/useWhen";
import { PAYMENT_ARGS } from "consts/feature-config";

export default function Start({
  loggedWeights,
  navigate,
  setLoggedWeights,
  prevCustomerLoggedWeights,
  setprevCustomerLoggedWeights,
}) {
  //reset logged weights but keep a copy in case user navigates back
  useEffect(() => {
    if (loggedWeights.length > 0) {
      setLoggedWeights([]);
    }
  }, [loggedWeights, setLoggedWeights]);

  //get price per unit
  const pricePerUnit = calculateEstimate(1);
  const pricePerUnitGift = useLocalizedCurrencyValue(pricePerUnit.gift);

  //translate
  const { t } = useTranslation();

  const showPayment = useWhen(PAYMENT_ARGS);

  return (
    <div className="flex flex-col items-center w-full h-full px-[4vh]">
      <div className="fixed flex top-[3vh] px-[3vh] justify-between w-full">
        {prevCustomerLoggedWeights.length !== 0 ? (
          <KioskStartButton
            iconShow={false}
            className="bg-[#0000000c] px-10 background "
            onClick={() => {
              setLoggedWeights(prevCustomerLoggedWeights);
              setprevCustomerLoggedWeights([]);
              navigate("finish");
            }}
          >
            <img src={ArrowBack} alt="Arrow icon" className="w-[2vh]" />
          </KioskStartButton>
        ) : (
          <div />
        )}
        <KioskStartButton
          className="font-semibold w-1/4"
          iconShow={false}
          onClick={() => navigate("terms")}
        >
          Start
        </KioskStartButton>
      </div>
      <h1 className="text-[80px] mt-[2vh]  text-white">
        LEGO® Brick Take Back
      </h1>
      <div className="flex flex-col gap-[0vh] items-center mt-[3vh] text-white">
        <p className="text-[112px] leading-[130%] text-center max-w-[45vh] mb-[5vh]  text-white">
          Trade in your <br />
          LEGO bricks for a LEGO e-Gift Card{showPayment && " or digital cash"}
        </p>
        <p className="text-[60px] max-w-[43vh] w-full text-center text-yellow font-bold mt-[2vh]">
          Chat with one of our
          <br />
          Brick Specialists to get started.
        </p>
        <p className="text-[50px] max-w-[43vh] w-full text-center font-light mt-[1vh]">
          Then weigh and verify your bricks to get your reward.
        </p>

        <p className="pt-[120px] text-[48px] font-bold text-center">
          We're rewarding you for trading in
          <br /> your spare LEGO bricks
        </p>

        <div className="flex gap-[3vh] justify-center mt-[3vh]">
          <div className="flex items-start text-center flex-nowrap gap-[1vh]">
            <img
              src={GiftCard}
              alt="Cash Icon"
              className="w-[8vh] aspect-[16/10] rounded-[.8vh]"
            />
            <div className="flex flex-col items-start gap-x-small text-[45px]">
              <div className="font-bold">
                {t("ui.reward_overview.giftcard_title")}
              </div>
              <div className="text-[38px] text-white font-light">
                {pricePerUnitGift} per pound of eligible bricks
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
